import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05),
    0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  padding: 30px 32px 40px;
  margin-bottom: 10px;
  text-align: center;
  gap: 12px;

  > p {
    font-size: 16px;
    margin-bottom: 20px;
  }

  > div {
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    button {
      padding: 8px 16px;
      background-color: transparent;
      border-radius: 4px;
      width: 100%;
      border: none;
      background-color: #ffe4b8;
      :hover {
        background-color: #f39500;
        color: #fff;
        font-weight: 600;
      }
    }
  }

  span {
    margin-bottom: 15px;
  }

  small {
    margin-top: 12px;
    width: 90%;
  }

  @media screen and (max-width: 766px) {
    padding: 30px 15px;
  }
`
